/**
 * Build PUT /IMAdmin/inbounds/rto body for RTO receive.
 *
 * Wrong-SKU rule: AWB/order lines marked differentSku are sent with quantityReceived 0;
 * the physically received products go in productsNotInOrder (InventoryProduct IDs).
 *
 * Faulty split: faultyQuantity is pieces of this receive that go to the return warehouse;
 * the rest go to Available. Legacy boolean `faulty` is derived when the whole batch is Faulty.
 */
import { withFaultyFields } from "../../app/components/inboundFaultySplit";

export function buildRtoReceivePayload({
  orderId,
  vendorId,
  orderItems = [],
  selectedOrderItemIds = [],
  orderItemData = {},
  differentSkuByItem = {},
  selectedProductIds = [],
  productsNotInOrder = {},
}) {
  const orderItemsArray = orderItems
    .filter((item) => selectedOrderItemIds.includes(item._id))
    .map((item) => {
      const isDifferentSku = !!differentSkuByItem[item._id];
      const data = orderItemData[item._id] || { quantityReceived: 0, faultyQuantity: 0 };
      if (isDifferentSku) {
        return withFaultyFields({
          _id: item._id,
          quantityReceived: 0,
          faultyQuantity: 0,
        });
      }
      return withFaultyFields({
        _id: item._id,
        quantityReceived: data.quantityReceived || 0,
        faultyQuantity: data.faultyQuantity || 0,
      });
    })
    .filter((item) => item.quantityReceived > 0 || !!differentSkuByItem[item._id]);

  const productsNotInOrderArray = selectedProductIds
    .filter((productId) => {
      const data = productsNotInOrder[productId];
      return data && data.quantityReceived > 0;
    })
    .map((productId) =>
      withFaultyFields({
        _id: productId,
        quantityReceived: productsNotInOrder[productId].quantityReceived,
        faultyQuantity: productsNotInOrder[productId].faultyQuantity || 0,
      })
    );

  return {
    orderId,
    vendorId,
    orderItems: orderItemsArray,
    productsNotInOrder: productsNotInOrderArray,
  };
}
